export const UAH_UA = 'грн.';
export const UAH = 'UAH';
export const RUR = 'RUR';
export const USD = 'USD';
